<template>
  <div id="czmm">
      <div class="lleft">
          <div class="logo">
                <img src="@/assets/logo2.png"  @click="$router.push('/')">
                <div>欢迎访问智能医学科研方案设计平台</div>
           </div> 
           <div class="copy">CopyRight 2012-2025 All Right Reserved 天创明达CreateMed </div>
      </div>
      <div class="lright">
            <div class="rightbox">
                <div class="tit">请重置密码</div>
                 <div  class="mt_30 dlfont">密码：</div>
                <el-input placeholder="请输入密码" type="password" class="inp" v-model="password"></el-input>
                <el-button class="logbtn" type="primary" @click="send"> 提交</el-button>
            </div>
      </div>
  </div>
  
</template>

<script>
import { setPasswordByEmail } from "@/api/index.js"
export default {
  data() {
    return {
      findtoken:'',
      password:''
    }
  },
  mounted() {
    this.findtoken=this.$route.query.findtoken
   
  },
  methods:{
    send(){
        if(this.password==''){
        this.$message.error('请输入密码');
        return
      }
       setPasswordByEmail({findtoken:this.findtoken,password:this.password}).then(res=>{
            if(res.code==1){
              this.$message({
                    message: '密码重置成功',
                    type: 'success'
                  });
                  this.$router.push('/login')
            }
        })
    }
  }
}
</script>

<style scoped lang="less">
#czmm {
  display: flex;position: absolute;top:0;left:0;right:0;bottom:0;
  .lleft {
    background:#F4F8FC;flex:4;height:100%;display:flex;justify-content: center;align-items:center; flex-direction:  column;
    .logo {margin-bottom:100px;
      font-size: 18px;text-align:center;height:calc(100% - 200px);display:flex;justify-content: center;align-items:center; flex-direction:  column;
      img {width:140px;margin-bottom:20px;cursor:pointer}
    }
    .copy {color:#7A7A7A;font-size:14px;text-align: center;}
  }
  .lright {
    flex:6;border-left:1px solid #D1D1D1;height:100%;display:flex;justify-content: center;align-items:center;
    .rightbox {
      width:460px;display:flex;justify-content: center;flex-direction:  column;text-align: left;
    }
    .tit {
      font-size:24px;font-weight: bold;
    }
    .dlfont {font-size:18px;font-weight: bold}
    .inp {width:100%;;margin-top:10px;
        .el-input__inner {
          height:50px;font-size:18px;border:1px solid #D3D3D3;
        }
    }
    .logbtn {
      margin-top:50px;
height: 60x;
background: #2397CA;
border-radius: 6px;font-size:22px;
    }
    .linkfont {color:#2397CA;font-weight: bold;font-size: 16px;cursor: pointer;}
  }
  .tipfont {font-size:18px;font-weight: bold}
}
</style>
